import axios from 'axios';

export const state = () => ({
    accessToken: null
});

export const getters = {
    accessToken: state => state.accessToken
};

export const mutations = {
    SET_ACCESS_TOKEN(state, accessToken) {
        state.accessToken = accessToken;
    },
};

export const actions = {
    async get({ commit }) {
        const res = await axios.$get(`/v1/oauth/access_tokens/permanent`);
        commit('SET_ACCESS_TOKEN', res.access_token);

        return res.access_token;
    },

    downloadBundle() {
        return axios.get('/v1/mcp_bundle', { responseType: 'blob' });
    }
};
